import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from './http-data.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DashboardService extends HttpDataService {
  public dataSubject = new BehaviorSubject(null);
  public data: any;

  constructor(protected injector: Injector) {
    super(injector, '/crawler');
  }

  loadData(clientId) {
    const url = `${this.baseUrl}/clients/${clientId}/groups-resume`;

    this.http.get(url).subscribe((res) => {
      this.data = res;
      this.dataSubject.next(this.data);
    });
    return this.dataSubject.asObservable();
  }
}
